import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class FlashSaleService {
static flashSaleCreate = async (values) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/flash-sales/create",
        data: values,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static flashSaleDetailsSearch = async (productId, status, rowsPerPage, page) => {
    try {
      console.log('status, productId',status, productId)
      let filter = [];

      if (status) {
        filter.push({'status': status})
      }

      if(productId){
        filter.push({'productId': productId})
      }

      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/flash-sales/admin/search",
        data: {
          filter: filter,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let productDetail = response.data.data;
      return productDetail;
    } catch (err) {
      throw err;
    }
  };

  static flashSaleDetailsID = async (flashSaleID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/flash-sales/admin/" + flashSaleID,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let flashSaleDetailID = response.data.data;

      return flashSaleDetailID;
    } catch (err) {
      throw err;
    }
  };

  static flashSaleDelete = async (flashSaleID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/flash-sales/" + flashSaleID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static flashSaleUpdate = async (flashSaleID, bodydata) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/flash-sales/" + flashSaleID,
        data: bodydata,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static flashSales = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/flash-sales/get/all",
        headers: {
            Authorization: `Bearer ${authToken}`,
          },
      });
      let flashSalesDetail = response.data.data;
      return flashSalesDetail;
    } catch (err) {
      throw err;
    }
  };

  static allFlashSaleProductsNames = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/flash-sales/view/all/names",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      console.log('response',response)
      let productsDetail = response.data.data.allProducts;

      return productsDetail;
    } catch (err) {
      throw err;
    }
  };

}
